import BaseService from "./BaseService";

export default class QuadroHorarioService extends BaseService {

  constructor(self) {
    super(self);
  }

  ObterQuadroHorarioAluno(parameters) {
    return this.ExecutaFetch("/api/QuadroHorario/ObterQuadroHorarioAluno", "POST", parameters);
  }

  ConfirmacaoHorarioAluno(parameters) {
    return this.ExecutaFetch("/api/QuadroHorario/ConfirmacaoHorarioAluno", "POST", parameters);
  }

  DesconfirmacaoHorarioAluno(parameters) {
    return this.ExecutaFetch("/api/QuadroHorario/DesconfirmacaoHorarioAluno", "POST", parameters);
  }
}